export default "__VITE_ASSET__CBl0$ROR__"